import React from 'react';
import cx from 'classnames';

export default class Ripple extends React.PureComponent {
  render() {
    return (
      <span
        className={cx(`ripple-effect-${this.props.type}`, this.props.className)}
        style={{ top: this.props.y, left: this.props.x }} >
      </span>
    );
  }
}

Ripple.propTypes = {
  x: React.PropTypes.number,
  y: React.PropTypes.number,
  type: React.PropTypes.string.isRequired,
  className: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/component/Ripple.jsx